import React, { Component } from 'react';
import Chart from 'chart.js';
import { connect } from 'react-redux';
import darkGreenCircle from './../../images/dark_green_circle.png';
import darkPurpleCircle from './../../images/dark_purple_circle.png';
import lightGreenCircle from './../../images/light_green_circle.png';
import PropTypes from 'prop-types';

class FeatureChart extends Component {
    constructor(props) {
        super(props)
        this.canvasRef = React.createRef();
        this.handleNavigate = this.handleNavigate.bind(this);
    }

    handleNavigate(e) {
        const value = this.featureChart.getElementsAtEvent(e)[0]._model.label
        this.props.property.history.push(`/view_scenario_catalogue/{"feature_mapping":"${this.props.type}_${value}"}`)
    }

    componentDidUpdate() {
        this.featureChart.data.labels = this.props.featureLabel;
        this.featureChart.data.datasets[0].data = this.props.featureData;
        this.featureChart.update();
    }

    componentDidMount() {
        this.featureChart = new Chart(this.canvasRef.current, {
            type: 'doughnut',
            options: {
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                responsive: true,
                onClick: (e) => { this.handleNavigate(e) }
            },
            data: {
                labels: this.props.featureLabel,
                datasets: [{
                    data: this.props.featureData,
                    backgroundColor: ['#428003', '#622AD8', '#CBFF68']
                }]
            }
        });

    }

    render() {
        return (
            <div>
                <div className="card">
                    <div className="card-body">
                        <h6 style={ this.props.type === 'passenger'?
                            {color: "#757AF7", fontWeight: "bold"}
                            :  { color: "#464646", fontWeight: "bold" }}
                        >
                            Feature Mapping
                        </h6>
                        <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap"}}>
                            <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                <button style={{ paddingLeft: "4%"}} className="text-left">
                                    <img alt="" src={darkGreenCircle} /> { this.props.type === "passenger" ? "Highway Pilot" : "Hub - Hub" }
                                </button>
                            </div>
                        </div>
                        <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap", paddingLeft: '2%'}}>
                            <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                <button style={{ paddingLeft: "4%"}} className="text-left">
                                    <img alt="" src={darkPurpleCircle} /> { this.props.type === "passenger" ? "Urban Pilot" : "Parking Assist" }
                                </button>
                            </div>
                        </div>
                        <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap", paddingLeft: "2%" }}>
                            <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                <button style={{ paddingLeft: "4%"}} className="text-left">
                                    <img alt="" src={lightGreenCircle} /> { this.props.type === "passenger" ? "Valet Parking" : "Auto-Docking" }
                                </button>
                            </div>
                        </div>
                        <div>
                            <canvas id="featureChart" style={{ width: "400px", height: "400px" }} ref={this.canvasRef}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
FeatureChart.propTypes={
property:PropTypes.string,
type:PropTypes.string,
featureLabel:PropTypes.string,
featureData:PropTypes.string,
}
FeatureChart.defaultProps= {
property:[],
type:[],
featureLabel:[],
featureData:[],
}
const mapStateToProps = (state) => {
    return {
        type: state.toggleState.text,
        featureLabel: state.toggleState.featureMappingLabel,
        featureData: state.toggleState.featureMappingData
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }
export default connect(mapStateToProps)(FeatureChart)
